module.exports = __webpack_public_path__ + "static/img/logo2.da7df5fd.png";